import { Textarea } from '@chakra-ui/react'
import { useTranslation } from 'react-i18next'

import { Box } from '@/components/ui/box'
import { Text } from '@/components/ui/typography'
import useColorModeValue from '@/hooks/useColorModeValue'
import { IField } from '@/types/tasksApprovals'

const AwardReason = ({
    item,
    reason,
    limit = 600,
    onChange,
}: {
    item: IField
    reason: string
    limit?: number
    onChange: (reason: string) => void
}) => {
    const { t } = useTranslation()
    return (
        <Box py="8px" px="24px">
            <Text fontSize={12} pb="4px">
                {item.name}
            </Text>
            <Textarea
                onChange={(e) => {
                    if (e.target.value.length <= limit) {
                        onChange(e.target.value.trimStart())
                    }
                }}
                variant="gsk"
                minH="84px"
                style={{ caretColor: 'var(--chakra-colors-orange-400)' }}
                value={reason}
                maxLength={limit}
            />
            <Text pb="12px" fontSize="12px" pt="4px" color={useColorModeValue('gray.500', 'white')}>
                {t('tasksApprovals.grpDrawer.awardReasonLimit', { limit })}
            </Text>
        </Box>
    )
}

export default AwardReason
